import { Box, Grid, Typography } from "@mui/material";
import { sendCustomEvent } from "common/utility";
import React, { memo, useEffect, useState } from "react";
import { AUDITEVENTTYPE } from "services/trackService";
import { Member } from "types/Member";
import {
  accessCardLink,
  getPrimeLink,
  PrimeLandingPages,
  payspanLink,
} from "services/ssoService";
import { env$ } from "services/subjects";
import { Post } from "components/molecules/Post";
export type HomeTilesSectionProps = {
  member?: Member;
};

export const HomeTilesSection = memo(function HomeTilesSection({
  member,
}: HomeTilesSectionProps): JSX.Element {
  const [providerSearchSite, setProviderSearchSite] = useState("");
  useEffect(() => {
    env$.subscribe({
      next: (env) => {
        setProviderSearchSite(
          env === "prod"
            ? "https://providersearch.alignmenthealthplan.com"
            : "https://ava-providersearch-wu-uat.azurewebsites.net"
        );
      },
    });
  }, []);
  const posts = [
    {
      icon: "doctor",
      header: `Get Virtual Care`,
      subHeader: `Talk to your clinician by phone or video`,
      to: "/virtual-care",
    },
    {
      icon: "credit-card",
      header: "Access Card Balance",
      subHeader: `Check your balance`,
      href: accessCardLink,
      target: "_blank",
      onClick: () => {
        sendCustomEvent({
          eventType: AUDITEVENTTYPE.MemberPortalViewMyAccessCardTile,
        });
        sendCustomEvent({ eventType: AUDITEVENTTYPE.MemberPortalSSOInComm });
      },
    },
    {
      icon: "reception-bell",
      header: `Access Concierge`,
      subHeader: `Send your concierge a message`,
      to: "/message-center",
    },
    {
      icon: "medication",
      header: "Find a Drug",
      subHeader: "View the prescription drugs covered by your plan",
      href: getPrimeLink(PrimeLandingPages.FINDADRUG),
      target: "_blank",
    },
    {
      icon: "hospital",
      header: "Find A Provider",
      subHeader: "Search for a doctor or health care facility",
      href: providerSearchSite,
      target: "_blank",
    },
    {
      icon: "credit-cards",
      header: "Pay My Premium",
      subHeader: `Make a payment online`,
      href: payspanLink,
      target: "_blank",
    },
  ];
  return member && !member.termed ? (
    <Box>
      <Box py={4}>
        <Typography variant="h2" textAlign="center">
          I would like to
        </Typography>
      </Box>
      <Grid
        container
        rowSpacing={{
          xs: 2,
          sm: 3,
        }}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        {posts.map((post, i) => (
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 4,
            }}
            key={i}
          >
            <Post {...post} key={i} height="100%" />
          </Grid>
        ))}
      </Grid>
    </Box>
  ) : (
    <Box component="br" />
  );
});
